import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../utils/hostname";
import url from "../url";
import { NewCategoryType } from "../redux/game/slice";

export type CategoriesResponse = {
  categories: NewCategoryType[];
};
export const useGetCategoriesList = (display: string, platform: number) => {
  const queryClient = useQueryClient();
  const { data, isLoading, isPending } = useQuery({
    queryKey: ["categories list", display],
    queryFn: () =>
      api(true, true, "v2").get<CategoriesResponse>(
        url.config.api.categories.list(display),
        {
          params: {
            platform,
          },
        },
      ),
  });
  const invalidateCategoriesList = async () => {
    await queryClient.invalidateQueries({
      queryKey: ["categories list", display],
    });
  };
  return {
    categories: data?.data?.categories || [],
    isLoading: isLoading || isPending,
    invalidateCategoriesList,
  };
};
